import CardiacArrest from '@juvare/common-web-ui/icons/CardiacArrest';
import ChildAbduction from '@juvare/common-web-ui/icons/ChildAbduction';
import CodeStroke from '@juvare/common-web-ui/icons/CodeStroke';
import GenericMedicalEmergency from '@juvare/common-web-ui/icons/GenericMedicalEmergency';
import InfantAbduction from '@juvare/common-web-ui/icons/InfantAbduction';
import MissingPatient from '@juvare/common-web-ui/icons/MissingPatient';
import MissingSeniorPatient from '@juvare/common-web-ui/icons/MissingSeniorPatient';
import PatientFall from '@juvare/common-web-ui/icons/PatientFall';
import RecycleIcon from '@juvare/common-web-ui/icons/Recycle';
import Triage from '@juvare/common-web-ui/icons/Triage';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import BallotIcon from '@mui/icons-material/Ballot';
import BusAlertIcon from '@mui/icons-material/BusAlert';
import CampaignIcon from '@mui/icons-material/Campaign';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import CoronavirusIcon from '@mui/icons-material/Coronavirus';
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import EnergySavingsLeafIcon from '@mui/icons-material/EnergySavingsLeaf';
import ErrorIcon from '@mui/icons-material/Error';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FlashOffIcon from '@mui/icons-material/FlashOff';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import ForkLeftIcon from '@mui/icons-material/ForkLeft';
import GppBadIcon from '@mui/icons-material/GppBad';
import GppGoodIcon from '@mui/icons-material/GppGood';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import HubIcon from '@mui/icons-material/Hub';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import PublicIcon from '@mui/icons-material/Public';
import SensorsIcon from '@mui/icons-material/Sensors';
import SevereColdIcon from '@mui/icons-material/SevereCold';
import TerrainIcon from '@mui/icons-material/Terrain';
import ThunderstormIcon from '@mui/icons-material/Thunderstorm';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import VolcanoIcon from '@mui/icons-material/Volcano';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import WarningIcon from '@mui/icons-material/Warning';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import WbTwilightIcon from '@mui/icons-material/WbTwilight';
import WindPowerIcon from '@mui/icons-material/WindPower';
import React from 'react';
import { useAlertUiTranslation } from '../../../../hooks';
export const alertIconMap = {
    fire: LocalFireDepartmentIcon,
    volcano: VolcanoIcon,
    thunderstorm: ThunderstormIcon,
    windPower: WindPowerIcon,
    flashOn: FlashOnIcon,
    flashOff: FlashOffIcon,
    lightbulb: LightbulbIcon,
    severeCold: SevereColdIcon,
    snow: AcUnitIcon,
    favorite: FavoriteIcon,
    coronavirus: CoronavirusIcon,
    deviceThermostat: DeviceThermostatIcon,
    recycling: RecycleIcon,
    energySavingsLeaf: EnergySavingsLeafIcon,
    error: ErrorIcon,
    warning: WarningIcon,
    gppBad: GppBadIcon,
    gppGood: GppGoodIcon,
    gppMaybe: GppMaybeIcon,
    hourglassFull: HourglassFullIcon,
    watchLater: WatchLaterIcon,
    volunteerActivism: VolunteerActivismIcon,
    busAlert: BusAlertIcon,
    carCrash: CarCrashIcon,
    public: PublicIcon,
    terrain: TerrainIcon,
    timelapse: TimelapseIcon,
    wbTwilight: WbTwilightIcon,
    sensors: SensorsIcon,
    hub: HubIcon,
    infantAbduction: InfantAbduction,
    childAbduction: ChildAbduction,
    missingPatient: MissingPatient,
    missingSeniorPatient: MissingSeniorPatient,
    genericMedicalEmergency: GenericMedicalEmergency,
    patientFall: PatientFall,
    codeStroke: CodeStroke,
    cardiacArrest: CardiacArrest,
    monitorHeart: MonitorHeartIcon,
    forkLeft: ForkLeftIcon,
    triage: Triage,
    ballot: BallotIcon,
    campaign: CampaignIcon, // default
};
export const AlertIcon = (props) => {
    var _a, _b;
    const { t } = useAlertUiTranslation();
    const icon = (_a = props.icon) !== null && _a !== void 0 ? _a : 'campaign';
    const SvgIconComponent = (_b = alertIconMap[icon]) !== null && _b !== void 0 ? _b : alertIconMap.campaign;
    return React.createElement(SvgIconComponent, Object.assign({}, props, { "aria-label": t(`common.icons.${icon}`) }));
};
